/* ============
 * Actions for the utilities module
 * ============
 *
 * The actions that are available on the
 * utilities module.
 */
import axios from 'axios'

export default {
  getDatetime ({commit}) {
    let api = process.env.API_UTILITIES + '/datetime'
    return new Promise((resolve, reject) => {
      axios.get(api)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/utilities/actions.js